import React from "react"

import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"
import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"
import NotificationStatus from "../../NotificationStatus"

const NotificationViewItemDates = ({ expires, not_before, isFetching }) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />
                Start date
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={1}
                maxLines={2}
            >
                <p>
                    {not_before ? not_before.format("llll") : "No start date"}
                </p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-headline" />
                Expiry date
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={1}
                maxLines={2}
            >
                <p>{expires ? expires.format("llll") : "No expiry date"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-status" />
                Status
            </h3>
            <ContentLoaderTags isFetching={isFetching} tags={1} tagLength={20}>
                <NotificationStatus expires={expires} not_before={not_before} />
            </ContentLoaderTags>
        </div>
    </div>
)

export default NotificationViewItemDates
